import { SectionItem } from '@features/shift-post-v2/components'
import {
  ACCEPTANCE_CRITERIA_OPTION,
  ShiftPostStep,
} from '@features/shift-post-v2/steps'
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons'
import { InfoBanner } from '@features/shift-post-v2/components/info-banner/info-banner'
import { connect } from 'formik'
import { SelectedBadgesList } from '@src/features/shift-post-v2/steps/screening-requirements-step/components/screening-section/components/selected-badges-list/selected-badges-list'
import { EditScreeningModal } from '@src/features/shift-post-v2/steps/screening-requirements-step/components/screening-section/modals/edit-screening-modal/edit-screening-modal'
import { useModal } from '@src/hooks/useModal'
import { selectAcceptanceCriteriaData } from '@src/features/shift-post-v2/state/shift-post-v2.selectors'
import { useSelector } from 'react-redux'
import { ShiftBadges } from './components'
import { IScreeningSectionProps } from './screening-section.types'
import { SectionItemText } from './screening-section.styles'

export const ScreeningSection = connect<IScreeningSectionProps>(
  ({ sourceStep }) => {
    const [isOpen, toggleModal, closeModal] = useModal()
    const isConfirmStep = sourceStep === ShiftPostStep.CONFIRM
    const isAutoAccept =
      useSelector(selectAcceptanceCriteriaData).selectedOption !==
      ACCEPTANCE_CRITERIA_OPTION.PERSONALLY_APPROVED
    const infoBannerMessages = isAutoAccept
      ? 'Contact your Account Manager to get additional screening requirements enabled for your account.'
      : 'The screening requirements cannot be selected because you chose the ‘Personally Approved Upshifters’ option in the acceptance criteria step.'

    return (
      <SectionItem
        title={
          sourceStep === ShiftPostStep.CONFIRM
            ? 'Screening Requirements'
            : 'Would you like to add extra screening requirements?'
        }
        isOptional={!isConfirmStep}
        hasEdit={isConfirmStep}
        onEdit={toggleModal}
      >
        {isConfirmStep ? (
          <>
            <SelectedBadgesList />

            <EditScreeningModal isOpen={isOpen} closeModal={closeModal} />
          </>
        ) : (
          <>
            <SectionItemText>
              Only allow Upshifters with the selected screening requirements to
              book this shift.
            </SectionItemText>

            <InfoBanner
              description={infoBannerMessages}
              icon={faInfoCircle}
              variant={isAutoAccept ? 'primary' : 'warning'}
            />

            {isAutoAccept && <ShiftBadges />}
          </>
        )}
      </SectionItem>
    )
  },
)
